<template>
  <div>
    <!-- Danışan odası kendi kabuğunu basar (`MeetingComponent`, `est-room--page`):
         logo + bağlantı durumu üst şeridi ve şifreli bağlantı notu + klinik
         telefonu alt şeridi bileşenin içindedir. Buradaki eski marka renkli
         header ve telif footer'ı ikinci bir kabuk oluşturuyordu. -->
    <router-view></router-view>
  </div>
</template>

<script>
  export default {
    name: 'MeetingLayout'
  }
</script>
